module.exports = __webpack_public_path__ + "static/3-dcf6366de64d2211afa61e9de23333c2.jpg";